module.exports = __webpack_public_path__ + "img/sub0.3c8484e0.jpg";